import { z } from 'zod';
import { ResponseUnmaskStateSchema } from '~/features/shared/market-content/responseUnmask.schemas';
import { listingSubspecialtySchema } from '~/features/types';
import { JobResponseAvailableActionsSchema, JobResponseTurnSchema } from '~/types/hlx/jobResponse';

export const OpportunityStatusSchema = z.enum([
  'MESSAGED',
  'APPLIED',
  'NEGOTIATING',
  'PENDING_ACCEPTANCE',
  'ACCEPTED',
  'REJECTED',
  'WITHDRAWN',
]);

export const OpportunityFilterSchema = z.enum(['all', 'active', 'accepted']);

export const NegotiationSenderSchema = z.enum(['PROVIDER', 'EMPLOYER']);

export const LatestNegotiationSchema = z.object({
  id: z.number().int().positive(),
  version: z.number(),
  sender: NegotiationSenderSchema,
  pricePerHour: z.string().nullable(),
  numOfShifts: z.number().nullable(),
  totalContractValue: z.string().nullable(),
});

export const ListingOwnerSchema = z.object({
  displayName: z.string(),
  masked: z.boolean(),
});

export const OpportunityListingSchema = z.object({
  id: z.number(),
  jobTitle: z.string(),
  jobType: z.string(),
  specialtyName: z.string().nullable(),
  generalSpecialtyFlag: z.boolean().optional(),
  subspecialties: z.array(listingSubspecialtySchema).optional(),
  workLocation: z.string(),
  stateCodes: z.array(z.string()),
  pricePerHour: z.string().nullable(),
  numOfShifts: z.number().nullable(),
  hoursPerShift: z.string().nullable(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
});

export const NegotiationVersionSchema = z.object({
  version: z.number(),
  sender: NegotiationSenderSchema,
  numOfShifts: z.number().nullable(),
  pricePerHour: z.string().nullable(),
  totalContractValue: z.string().nullable(),
  createdAt: z.string().nullable(),
});

export const JobOpportunitySchema = z.object({
  responseId: z.number(),
  status: OpportunityStatusSchema,
  turn: JobResponseTurnSchema,
  availableActions: JobResponseAvailableActionsSchema,
  appliedAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  isUnmasked: z.boolean(),
  unmaskState: ResponseUnmaskStateSchema,
  listing: OpportunityListingSchema,
  listingOwner: ListingOwnerSchema,
  latestNegotiation: LatestNegotiationSchema.nullable(),
  negotiations: z.array(NegotiationVersionSchema).default([]),
});

export const JobMessageSchema = z.object({
  id: z.number(),
  responseId: z.number(),
  messageBody: z.string(),
  senderProviderId: z.number().nullable(),
  senderEmployerId: z.number().nullable(),
  senderUserId: z.number(),
  negotiationId: z.number().nullable(),
  negotiationVersion: z.number().nullable(),
  createdAt: z.string(),
});
